import React from 'react';
import Loader from "../components/Loader";
import Navbar from '../components/Navbar';
import Carousel from '../components/Carousel';
import Features from '../components/Features';
import Footer from '../components/Footer';
import { useState, useEffect } from 'react';
import Courses from '../components/Courses';
import Testinomials from '../components/Testinomials';

function Home(){
    const [loading,setloading] = useState(true);
    useEffect(()=>{
        setTimeout(() => {
            setloading(false);
        },2000)
    });
    return (
        <div>
            {loading ? 
                (
                    <Loader/>
                ):
                (
                    <div>
                        <Navbar/>
                        <Carousel/>
                        <Features/>
                        <Courses/>
                        <Testinomials /> 
                        <Footer/>
                    </div>
                )
            }
            
        </div>
    )
}

export default Home;